import { Subscription, SubscriptionProvider } from './SubscriptionProvider';

/**
 * arbitrarySubscriber.  A subscriber that can be applied to anything
 * @return {SubscriptionProvider} The subscription model.
 */
const ArbitrarySubscriber = (() => {
  const buildSubscriptionFn = (key, fn) => (new Subscription({
    key,
    unsubscribeFn: () => {},
    callback: fn,
  }));

  // create a subscriptionProvider, and provide it with the buildSubscriptionFn
  return new SubscriptionProvider({ buildSubscriptionFn });
});

export default ArbitrarySubscriber;
